import _ from 'lodash';

export const handleToggle = (stateSlice, name) => {
  const index = _.findIndex(stateSlice, {name});

  return [
    ...stateSlice.slice(0, index),
    {
      ...stateSlice[index],
      showDetails: !stateSlice[index].showDetails
    },
    ...stateSlice.slice(index + 1)
  ];
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/plan/planHelpers.js
 **/